import { styled } from "@mui/material";
import { Button } from "@volt_developers/components";
import { useTranslation } from "react-i18next";

import { COMMON_TRANSLATION_KEYS } from "constants/commonTranslationsKeys";

import { FILTERS_TEST_IDS } from "../../../constants";

export interface SelectAllButtonProps {
  isSelectAllVisible: boolean;
  selectAll: () => void;
}

export function SelectAllButton({
  isSelectAllVisible,
  selectAll,
}: SelectAllButtonProps) {
  const { t } = useTranslation("common");

  if (!isSelectAllVisible) {
    return null;
  }

  return (
    <SelectAllButtonStyled
      data-testid={FILTERS_TEST_IDS.selectAllButton}
      size="small"
      variant="text"
      onMouseDown={selectAll}
    >
      {t(COMMON_TRANSLATION_KEYS.selectAll, { ns: "common" })}
    </SelectAllButtonStyled>
  );
}

const SelectAllButtonStyled = styled(Button)({
  minHeight: 20,
});
